export interface NewsItem {
  id: string;
  title: string;
  date: string;
  cover: string;
  summary: string;
  content: string[];
  relatedMovieIds: string[];
}

export const news: NewsItem[] = [
  {
    id: "1",
    title: "《雨后花园》入围年度最佳爱情片，主创团队亮相首映礼",
    date: "2024-09-18",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20an%20award%20ceremony%20stage%20bathed%20in%20violet%20spotlights%2C%20golden%20trophy%20silhouette%20in%20soft%20focus%2C%20mauve%20and%20blush%20tones%2C%20elegant%20celebratory%20mood%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20soft%20dramatic%20lighting&width=1200&height=700&seq=baihe-news-01&orientation=landscape",
    summary:
      "凭借细腻克制的叙事与出色的影像质感，《雨后花园》正式入围本届年度最佳爱情片，主创团队出席首映礼并分享幕后故事。",
    content: [
      "日前，备受关注的百合题材电影《雨后花园》正式宣布入围本届年度最佳爱情片。影片自点映以来便收获了观众与影评人的一致好评，被认为是最具诗意气质的爱情片之一。",
      "在首映礼现场，导演沈梧桐表示，影片想要表达的不是轰轰烈烈的爱情，而是两个人在漫长岁月里学会诚实面对自己内心的过程。“我们把大量的镜头交给了雨水、花园和沉默，因为有些情感本来就不需要用台词去解释。”",
      "主演周与安与林晓棠也分享了拍摄期间的感受。为呈现真实的园艺细节，两人在开拍前跟随专业园艺师学习了近一个月。林晓棠笑称，如今她已经能分辨出十几种不同品种的藤本月季。",
      "据悉，影片后续还将陆续登陆多个海外影展。制片方表示，希望通过这部作品，让更多人看到百合题材在表达深度上的更多可能。",
    ],
    relatedMovieIds: ["1", "5"],
  },
  {
    id: "2",
    title: "《追光少女》第二季正式官宣，原班人马回归",
    date: "2024-08-30",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20a%20clapperboard%20and%20script%20on%20a%20film%20set%20desk%2C%20warm%20violet%20and%20pink%20rim%20light%2C%20behind%20the%20scenes%20mood%2C%20subtle%20film%20grain%2C%20clean%20editorial%20composition%2C%20high%20detail%2C%20soft%20cinematic%20lighting&width=1200&height=700&seq=baihe-news-02&orientation=landscape",
    summary:
      "年度高分校园剧《追光少女》宣布启动第二季制作，主创原班人马将悉数回归，故事时间线将推进至大学生活。",
    content: [
      "口碑热度双丰收的《追光少女》正式官宣第二季。据制作方透露，第二季将继续由原班导演与编剧团队操刀，几位主演也确认回归。",
      "第一季以校园文化祭的舞台剧为线索，讲述了两名女孩用光影与声音相互治愈的故事。播出期间多次登上社交平台话题榜，被观众称为“今年最舍得给细节的青春剧”。",
      "第二季的故事时间线将推进至大学阶段，绫濑光与朝比奈遥将面对更现实的选择与更复杂的距离。“成长带来的拉扯感，会是第二季最重要的主题。”编剧在采访中这样透露。",
      "目前项目已进入前期筹备，预计将于明年与观众见面。",
    ],
    relatedMovieIds: ["2", "8"],
  },
  {
    id: "3",
    title: "盘点：2024 上半年最值得一看的六部百合剧集",
    date: "2024-07-12",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20a%20stack%20of%20film%20posters%20and%20a%20notebook%20on%20a%20marble%20desk%2C%20violet%20and%20blush%20ambient%20tones%2C%20curated%20list%20mood%2C%20gentle%20film%20grain%2C%20elegant%20editorial%20composition%2C%20high%20detail%2C%20soft%20warm%20lighting&width=1200&height=700&seq=baihe-news-03&orientation=landscape",
    summary:
      "从治愈系的日常小品到节奏明快的都市甜剧，编辑部整理了这一季度里口碑与完成度都相当出色的六部作品。",
    content: [
      "2024 年上半年，百合题材的创作呈现出更加多元的面貌。无论你偏爱慢热的文艺片，还是轻松的都市剧，都能在这份片单里找到心仪的选择。",
      "在治愈与日常赛道上，《深巷面包店》凭借扎实的生活细节脱颖而出，被不少观众评价为“深夜追剧必备”；而《第二杯半价》则以轻喜剧的方式，把市井里的甜意拍得恰到好处。",
      "在情感深度上，《玻璃花房》用极致的影像美学处理了一段跨越十年的克制情感，是上半年讨论度最高的作品之一；《海风里的信》则把“守望”这一主题拍得余味悠长。",
      "此外，来自海外的《追光少女》与《蔷薇契约》也各自收获了稳定的口碑。完整片单与评分详情，可前往本站专题合集页查看。",
    ],
    relatedMovieIds: ["8", "6", "11", "5"],
  },
  {
    id: "4",
    title: "《玻璃花房》幕后花絮公开，一座花房拍了四十二天",
    date: "2024-06-25",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20a%20greenhouse%20film%20set%20with%20soft%20pink%20lighting%20and%20camera%20rig%2C%20behind%20the%20scenes%20mood%2C%20mauve%20and%20pearl%20tones%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20soft%20luminous%20lighting&width=1200&height=700&seq=baihe-news-04&orientation=landscape",
    summary:
      "剧组公开了《玻璃花房》的幕后制作特辑，还原了那座成为全片情感核心的玻璃花房，从搭建到布光的完整过程。",
    content: [
      "作为影片最重要的场景，那座玻璃花房并非实景，而是剧组历时两个月搭建、占地近三百平方米的实体布景。",
      "美术团队透露，为了让玻璃的折射效果在镜头里足够自然，他们反复调整了玻璃厚度与花房朝向。“我们希望光线穿过玻璃时，是温柔的、会呼吸的，而不是冷冰冰的。”",
      "片中出现的数十种植物均为真实栽培，并由专业园艺团队全程养护。仅花房的正式拍摄就持续了四十二天，横跨了完整的开花周期。",
      "这段幕后特辑现已随影片相关物料一同公开，喜欢影片影像风格的观众不容错过。",
    ],
    relatedMovieIds: ["11", "1"],
  },
  {
    id: "5",
    title: "专访：新生代演员谈诠释细腻情感的挑战",
    date: "2024-05-20",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20a%20quiet%20interview%20room%20with%20microphone%20and%20warm%20lamp%2C%20violet%20and%20rose%20ambient%20tones%2C%20intimate%20conversation%20mood%2C%20subtle%20film%20grain%2C%20elegant%20editorial%20composition%2C%20high%20detail%2C%20warm%20soft%20lighting&width=1200&height=700&seq=baihe-news-05&orientation=landscape",
    summary:
      "几位活跃在百合题材作品中的新生代演员，聊了聊她们如何理解角色、如何用表演传递那些“说不出口”的情绪。",
    content: [
      "在一部以情感为核心的作品里，最难演的往往不是哭戏，而是沉默。几位受访演员都提到了同一个词：留白。",
      "“观众比我们想象中更聪明。”一位演员说，“你不需要把每一个情绪都演满，有时候一个停顿、一次移开的目光，传递的信息反而更多。”",
      "谈及百合题材的表演，她们普遍认为，最重要的不是刻意强调关系，而是把两个人之间的“在意”拍得真实可信。“当观众相信她们真的在乎对方，题材本身就不需要被反复解释。”",
      "她们也期待未来能有更多元的剧本，“不只有甜，也有成长、有挣扎、有普通人的柴米油盐。”",
    ],
    relatedMovieIds: ["1", "2", "8"],
  },
  {
    id: "6",
    title: "从《海风里的信》看百合影视的叙事新趋势",
    date: "2024-04-08",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20an%20open%20screenplay%20with%20seaside%20postcard%20and%20pen%2C%20muted%20violet%20and%20dusty%20pink%20tones%2C%20thoughtful%20essay%20mood%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20soft%20warm%20lighting&width=1200&height=700&seq=baihe-news-06&orientation=landscape",
    summary:
      "不再依赖强烈的戏剧冲突，越来越多的作品选择用“留白”与“日常”来承载情感，这或许是题材走向成熟的信号。",
    content: [
      "过去，百合题材常常被寄望于用强烈的情节来证明自己；而如今，我们看到了另一种更从容的表达方式。",
      "《海风里的信》几乎没有激烈的冲突，它把叙事重心放在了一个人如何长久地、安静地守护一份感情上。正是这种克制，让影片的情感重量反而更加沉甸甸。",
      "这种转向并非削弱了题材的力量，恰恰相反，它意味着创作者开始相信观众有能力读懂那些没有说出口的部分。",
      "当一部作品不再需要反复强调“这是什么类型”，而是专注于讲好两个具体的人的故事时，题材才真正拥有了被平等看待的底气。",
    ],
    relatedMovieIds: ["5", "9", "3"],
  },
];